import React from "react";

interface Props {
	handleClick?: (event: React.MouseEvent) => void;
	handleKeyDown?: (event: React.KeyboardEvent) => void;
	className?: string;
	label: string;
	to: string;
	children: React.ReactNode;
}

// Old props for forward ref
// interface RefLinkProps {
// 	children: React.ReactNode;
// 	href: string;
// }

function CustomLink({
	handleClick,
	handleKeyDown,
	className,
	label,
	to,
	children,
}: Props) {
	return (
		<a
			href={to}
			className={`list-group-card-link ${className ? className : ""}`}
			aria-label={label}
			onClick={handleClick}
			onKeyDown={handleKeyDown}>
			{children}
		</a>
	);
}

export default CustomLink;

// Old custom link functionality below with forwardRef. This has been taken out as it made the admin activity checkboxes run slow
// by forcing a rerender each time something was checked. If this functionality needs adding again then the speed problem needs fixing.

// export default function CustomLink({
// 	handleClick,
// 	handleKeyDown,
// 	className,
// 	label,
// 	to,
// 	children,
// }: Props) {
// 	// Allows custom click and keydown functionality to be used on
// 	// an anchor
// 	const refLink = React.forwardRef(
// 		({ children, href }: RefLinkProps, ref: Ref<HTMLAnchorElement>) => {
// 			return (
// 				<a
// 					href={href}
// 					ref={ref}
// 					className={`list-group-card-link ${
// 						className ? className : ""
// 					}`}
// 					aria-label={label}
// 					onClick={handleClick}
// 					onKeyDown={handleKeyDown}>
// 					{children}
// 				</a>
// 			);
// 		}
// 	);
// 	return (
// 		<Link to={to} component={refLink}>
// 			{children}
// 		</Link>
// 	);
// }
